import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';
import { CommandPalette } from './CommandPalette';
import { useGlobalScan } from '../app/useGlobalScan';
import { useServerTheme } from '../api/themes';

// Shell per design-system §3: #app grid (sidebar 248px + main), sticky navy sidebar (a drawer below 1000px), white sticky
// top bar, #content (padding, max 1500px). useGlobalScan is mounted exactly once here.
export function AppShell() {
  useGlobalScan();
  // reconciles the browser's remembered theme with the account's, so a choice follows the person between machines and
  // an administrator's default reaches everyone who has not chosen one
  useServerTheme(true);
  const { t } = useTranslation();
  return (
    <div id="app">
      <SideNav />
      <CommandPalette />
      <div id="main">
        <TopBar />
        <div id="content">
          <Suspense fallback={<p className="muted small">{t('app.loading')}</p>}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
